module.exports = __webpack_public_path__ + "static/media/header_logo.96f06819.png";